import { useEffect } from 'react';
import { useLocation } from 'react-router';

/**
 * Component that scrolls the page to the top whenever the route changes.
 * This fixes the issue where navigating to a new page keeps the scroll position
 * from the previous page (RSD-1313).
 */
export const ScrollToTop: React.FC = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

